import { IconButton } from '@mui/material'
import { CloudDownload } from '@mui/icons-material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useExtractionCalls } from '../hooks'
import { useExtractionDialogs } from '../hooks/extraction-dialogs.hook'
import DateFnsAdapter from '@date-io/date-fns'

export const ExtractionButton = ({ classes }) => {
  const dateFns = new DateFnsAdapter()

  const email = useSelector((state) => state.profile.user.email)
  const role = useSelector((state) => state.global.role)
  const permissions = useSelector((state) => state.global.permissions)
  const hasGestionSspp = permissions?.gestion_sspp

  const { requestNewExtractionByEmail, launchNewExtractionByEmail, launchNewSSPPExtraction } =
    useExtractionCalls()
  const { confirmExtractionProcess, confirmExtractionProcessByDates, announcePendingProcess } =
    useExtractionDialogs()

  const handleExtractionRequest = async () => {
    try {
      await requestNewExtractionByEmail()

      if (role === 'e_commerce') {
        confirmExtractionProcess(email, launchNewExtractionByEmail)
      } else if (role === 'soporte_procesos' || hasGestionSspp) {
        confirmExtractionProcessByDates(email, ({ from, to }) => {
          launchNewSSPPExtraction({
            params: {
              from_date: dateFns.format(dateFns.date(from), 'dd/MM/yyyy'),
              to_date: dateFns.format(dateFns.date(to), 'dd/MM/yyyy'),
            },
          })
        })
      }
    } catch (code) {
      if (code === 'already started') {
        announcePendingProcess(email)
      }
    }
  }

  return (
    <IconButton className={classes.iconButton} onClick={handleExtractionRequest} size="large">
      <CloudDownload sx={{ color: 'black' }} />
    </IconButton>
  )
}

export default ExtractionButton
